import { SelectOption } from '@/components/form/Select/types';

export function sortByLabel(a: SelectOption, b: SelectOption) {
  return a.label.localeCompare(b.label);
}
